import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import Navbar from "../../Components/Navbar";
import Footer from "../Home/Footer";
import EngineeringIcon from "@mui/icons-material/Engineering";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const Upcoming = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#F9FAFB",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Navbar />

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 8, md: 12 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container maxWidth="md">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center", position: "relative", zIndex: 1 }}
          >
            {/* Animated Icon */}
            <motion.div
              animate={{
                y: [0, -20, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{ display: "inline-block", marginBottom: "32px" }}
            >
              <Box
                sx={{
                  background:
                    "linear-gradient(135deg, #B02F00 0%, #FF5722 100%)",
                  p: 3,
                  borderRadius: "24px",
                  boxShadow: "0px 20px 40px rgba(176, 47, 0, 0.3)",
                  display: "flex",
                }}
              >
                <EngineeringIcon sx={{ color: "#FFFFFF", fontSize: "48px" }} />
              </Box>
            </motion.div>

            {/* Main Text */}
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Inter",
                fontWeight: 700,
                color: "#FF5722",
                letterSpacing: "4px",
                textTransform: "uppercase",
                mb: 2,
              }}
            >
              Construction Division
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: { xs: "48px", md: "84px" },
                lineHeight: 1.1,
                color: "#1C1917",
                mb: 3,
                letterSpacing: "-2px",
              }}
            >
              Something Great is <br />
              <Box component="span" sx={{ color: "#FF5722" }}>
                Under Construction
              </Box>
            </Typography>

            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "18px", md: "22px" },
                color: "#78716C",
                maxWidth: "600px",
                mx: "auto",
                lineHeight: 1.6,
                mb: 6,
              }}
            >
              We are currently designing and planning our next generation of
              landmark projects. Stay tuned for revolutionary developments that
              will redefine the city's skyline.
            </Typography>

            {/* CTA and Notification */}
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              {/* <Button
                variant="contained"
                startIcon={<RocketLaunchIcon />}
                sx={{
                  background:
                    "linear-gradient(135deg, #B02F00 0%, #FF5722 100%)",
                  color: "#FFFFFF",
                  fontFamily: "Inter",
                  fontWeight: 700,
                  fontSize: "16px",
                  px: 4,
                  py: 2,
                  borderRadius: "12px",
                  textTransform: "none",
                  boxShadow: "0px 10px 20px rgba(176, 47, 0, 0.2)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #FF5722 0%, #B02F00 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0px 15px 30px rgba(176, 47, 0, 0.3)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Notify Me on Launch
              </Button> */}
              {/* <Button
                variant="outlined"
                sx={{
                  borderColor: "#E7E5E4",
                  color: "#1C1917",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "16px",
                  px: 4,
                  py: 2,
                  borderRadius: "12px",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#1C1917",
                    backgroundColor: "transparent",
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                View Existing Projects
              </Button> */}
            </Stack>
          </motion.div>
        </Container>

        {/* Abstract Background Decoration */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: "100%",
            zIndex: 0,
            opacity: 0.4,
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "10%",
              left: "10%",
              width: "30vw",
              height: "30vw",
              background:
                "radial-gradient(circle, rgba(255, 87, 34, 0.05) 0%, transparent 70%)",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "10%",
              right: "10%",
              width: "40vw",
              height: "40vw",
              background:
                "radial-gradient(circle, rgba(176, 47, 0, 0.03) 0%, transparent 70%)",
              borderRadius: "50%",
            }}
          />
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

export default Upcoming;
